module.exports = "<!--todo andrey resolve validation wizard problem  (click)=\"selectTab()\" -->\n<li>\n    <a [ngClass]=\"isSelected ? 'selected': (isDone ? 'done' : 'disabled')\" class=\"wizard-link\">\n\n        <span class=\"step_no\">\n            <ng-content select=\".tab-title\"></ng-content>\n        </span>\n\n        <span class=\"step_descr\">\n           <ng-content select=\".tab-description\"></ng-content>\n        </span>\n\n    </a>\n</li>"


//////////////////
// WEBPACK FOOTER
// ./src/common/components/wizard/wizard.tab.template.html
// module id = 926
// module chunks = 0